import { API_URL } from 'core/infra/environment'
import { AlreadyExistsError } from 'core/infra/errors/AlreadyExistsError'
import { HttpClient } from 'core/infra/http/HttpClient'

import { sentry } from 'legacy/utils/sentry'

import { type PreferredLane } from '../domain/PreferredLane'
import { PreferredLaneRepository } from '../infra/PreferredLaneRepository'

export type AddPreferredLaneFactoryDependencies = {
  repository: PreferredLaneRepository
}

export function addPreferredLaneFactory({ repository }: AddPreferredLaneFactoryDependencies) {
  return async function addPreferredLaneImpl(
    preferredLane: PreferredLane,
    config?: { signal?: AbortSignal }
  ) {
    try {
      return await repository.addPreferredLane(preferredLane, config)
    } catch (error) {
      if (error instanceof AlreadyExistsError) {
        throw error
      }

      const newError = new Error('Could not add preferred lane', { cause: error })
      sentry.log(newError)
      throw newError
    }
  }
}

export function addPreferredLane(preferredLane: PreferredLane, config?: { signal?: AbortSignal }) {
  const httpClient = new HttpClient(API_URL)
  const repository = new PreferredLaneRepository({ httpClient })
  const newAddPreferredLane = addPreferredLaneFactory({ repository })

  return newAddPreferredLane(preferredLane, config)
}
